import { render, staticRenderFns } from "./AgentTicketList.vue?vue&type=template&id=31e2a394&scoped=true"
import script from "./AgentTicketList.vue?vue&type=script&lang=js"
export * from "./AgentTicketList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e2a394",
  null
  
)

export default component.exports